export function search($) {
  jQuery(document).ready(function ($) {
    var searchWithAIButton = document.querySelector(".search-with-ai");
    if (searchWithAIButton) {
      searchWithAIButton.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent default button behavior

        // Get the current search query from URL
        var urlParams = new URLSearchParams(window.location.search);
        var userQuery = urlParams.get("s") || ""; // Default to empty if no search term exists

        $.ajax({
          url: think_localize_obj.ajax_url,
          type: 'POST',
          data: {
            action: 'get_client_id',
            user_query: userQuery // Send the extracted search query
          },
          success: function success(response) {
            if (response.success) {
              var cid = response.data.cid;
              var userkey = response.data.xuserkey;
              var baseUrl = window.location.origin + '/';

              // Construct new URL parameters
              var searchParams = new URLSearchParams({
                s: userQuery,
                // Maintain the original search query
                cid: cid,
                // Append the conversation ID
                user: userkey
              });

              // Redirect to the updated URL
              window.location.href = "".concat(baseUrl, "?").concat(searchParams.toString());
            } else {
              console.error('Error:', response.data.error);
            }
          },
          error: function error(xhr, status, _error) {
            console.error('AJAX Error:', _error);
          }
        });
      });
    }
  });
  jQuery(document).ready(function ($) {
    var searchForms = document.querySelectorAll("#searchform");
    var baseUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port) {
      baseUrl += ":" + window.location.port; // Append port if available
    }
    searchForms.forEach(function (searchForm) {
      var toggleButton = searchForm.querySelector("#toggleButton");
      var toggleIcon = searchForm.querySelector("#toggleIcon");
      var toggleStatus = searchForm.querySelector("#toggleStatus");

      // Handle toggle button state
      toggleButton.onclick = function () {
        var currentState = toggleButton.getAttribute("data-state");
        if (currentState === "off") {
          toggleButton.setAttribute("data-state", "on");
          toggleIcon.src = baseUrl + "/wp-content/themes/malta-invest/assets/src/img/icons/AiOn.svg";
          toggleStatus.innerHTML = "On";
          // console.log('on');
        } else {
          toggleButton.setAttribute("data-state", "off");
          toggleIcon.src = baseUrl + "/wp-content/themes/malta-invest/assets/src/img/icons/AiOff.svg";
          toggleStatus.innerHTML = "Off";
          // console.log('of');
        }
      };

      // Handle form submission
      searchForm.onsubmit = function (event) {
        var toggleState = toggleButton.getAttribute("data-state");
        if (toggleState === "on") {
          var searchInput = searchForm.querySelector("input[name='s']"); // Select input field
          var searchQuery = searchInput ? searchInput.value : "";
          event.preventDefault(); // Prevent default form submission

          $.ajax({
            url: think_localize_obj.ajax_url,
            type: 'POST',
            data: {
              action: 'get_client_id',
              user_query: searchQuery
            },
            success: function success(response) {
              if (response.success) {
                var cid = response.data.cid;
                var userkey = response.data.xuserkey;
                // Construct the new URL with ?s= and the cid
                var _baseUrl = window.location.origin + '/';
                var _searchInput = searchForm.querySelector("#s");
                var _searchQuery = _searchInput ? _searchInput.value : "";
                var searchParams = new URLSearchParams({
                  s: _searchQuery,
                  // Include the current search query
                  cid: cid,
                  // Append the conversation ID
                  user: userkey
                });

                // Redirect to the updated URL
                window.location.href = "".concat(_baseUrl, "?").concat(searchParams.toString());
              } else {
                console.error('Error:', response.data.error);
              }
            },
            error: function error(xhr, status, _error2) {
              console.error('AJAX Error:', _error2);
            }
          });
        }
      };
    });
  });
  jQuery(document).ready(function ($) {
    var baseUrl = window.location.protocol + "//" + window.location.hostname;
    // Check if the URL has a 'cid' parameter
    var urlParams = new URLSearchParams(window.location.search);
    var cid = urlParams.get('cid'); // Get 'cid' from the URL query string
    var user = urlParams.get('user'); // Get 'user' from the URL query string
    var searchTerm = urlParams.get('s'); // Get search term 's'
    // console.log(cid);
    // console.log(user);
    // console.log(searchTerm);
    if (cid) {
      // Send an AJAX request to WordPress
      jQuery.ajax({
        url: think_localize_obj.ajax_url,
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'botpress_workflow',
          cid: cid,
          user: user,
          s: searchTerm
        },
        success: function success(response) {
          if (response.success) {
            // If successful, populate the search results
            var botResponse = response.data.bot_response ? response.data.bot_response : 'No response from bot';
            if (botResponse.includes("I'm sorry") || botResponse.includes("I couldn't find specific information")) {
              jQuery('#ai-search-results').html("<img class='mb-1' src='" + baseUrl + "/wp-content/themes/malta-invest/assets/src/img/icons/info.svg'><h4>AI couldn't generate a response for your query.</h4><p>The AI is designed to provide answers based on the information available in our curated library. Unfortunately, your query didn’t match the content within these parameters.</p><div class='d-flex mt-1'><button class='button-primary my-auto' data-bs-toggle='modal' data-bs-target='#searchModal'>Modify Search</button></div>");
            } else {
              jQuery('#ai-search-results').html('<p class="mb-0">' + botResponse + '</p>');
            }
          } else {
            // console.log(response);
            jQuery('#ai-search-results').html("<img class='mb-1' src='" + baseUrl + "/wp-content/themes/malta-invest/assets/src/img/icons/info.svg'><h4>AI couldn't generate a response for your query.</h4><p>The AI is designed to provide answers based on the information available in our curated library. Unfortunately, your query didn’t match the content within these parameters.</p><div class='d-flex mt-1'><button class='button-primary my-auto' data-bs-toggle='modal' data-bs-target='#searchModal'>Modify Search</button></div>");
          }
        },
        error: function error() {
          // console.log(response);
          jQuery('#ai-search-results').html("<img class='mb-1' src='" + baseUrl + "/wp-content/themes/malta-invest/assets/src/img/icons/info.svg'><h4>Oops! Something went wrong.</h4><p>We couldn't process your request. Please try again or switch to standard search.</p><div class='d-flex mt-1'><button class='button-primary my-auto' onclick='window.location.reload();'>Try Again</button></div>");
        }
      });
    }
  });
}